// Author Liang Gang Qiang
// Date 2021-12-10 14:28:23

class SithMesQualityInspectCommonTemplate {
constructor({
        id = null,
        resultId = '',
        position = '',
        designValue = '',
        actualValue = '',
        equipNumber = '',
        qualified = '',
        remark = ''}
= {}) {
    this.id = id;
    this.resultId = resultId;
    this.position = position;
    this.designValue = designValue;
    this.actualValue = actualValue;
    this.equipNumber = equipNumber;
    this.qualified = qualified;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesQualityInspectCommonTemplate();
}

const withOperationVoConfigs = [
        {
        key: 'inspectTaskCode',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.inspectTaskCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.projectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.projectName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'orderCode',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.orderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationSeq',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.operationSeq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'position',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.position',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'designValue',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.designValue',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualValue',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.actualValue',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'equipNumber',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.equipNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualified',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.qualified',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'status',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '已创建' },
                            { value: '2', text: '已保存' },
                            { value: '3', text: '已释放' }
            ]
        }
        }
    ]
    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectTaskCode',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.inspectTaskCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.projectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.projectName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'orderCode',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.orderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationSeq',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.operationSeq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'position',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.position',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'designValue',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.designValue',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualValue',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.actualValue',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'equipNumber',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.equipNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualified',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.qualified',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'status',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '已创建' },
                            { value: '2', text: '已保存' },
                            { value: '3', text: '已释放' }
            ]
        }
        }
    ])}
const withOutVoConfigs = [
        {
        key: 'inspectTaskCode',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.inspectTaskCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'position',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.position',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'designValue',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.designValue',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'actualValue',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.actualValue',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'equipNumber',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.equipNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualified',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.qualified',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'status',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '已创建' },
                            { value: '2', text: '已保存' },
                            { value: '3', text: '已释放' }
            ]
        }
        }
    ]

const filter = {
    idFilter : '',
    idListFilter : [],
    resultIdFilter : '',
    inspectTaskCodeFilter : '',
    inspectTaskIdFilter : '',
    projectCodeFilter : '',
    projectNameFilter : '',
    orderCodeFilter : '',
    operationSeqFilter : '',
    positionFilter : '',
    designValueFilter : '',
    actualValueFilter : '',
    equipNumberFilter : '',
    qualifiedFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'inspectTaskCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.inspectTaskCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.projectCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectNameFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.projectName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'orderCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.orderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operationSeqFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.operationSeq',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'positionFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.position',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'designValueFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.designValue',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'actualValueFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.actualValue',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'equipNumberFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.equipNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'qualifiedFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.qualified',
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
];
const withOperationFilterConfigs = [
        {
        key: 'inspectTaskCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.inspectTaskCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.projectCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectNameFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.projectName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'orderCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.orderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operationSeqFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.operationSeq',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'positionFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.position',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'designValueFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.designValue',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'actualValueFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.actualValue',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'equipNumberFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.equipNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'qualifiedFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.qualified',
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
];
const withOutFilterConfigs = [
        {
        key: 'inspectTaskCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.inspectTaskCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'positionFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.position',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'designValueFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.designValue',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'actualValueFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.actualValue',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'equipNumberFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.equipNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'qualifiedFilter',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.filter.qualified',
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'resultId',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.entity.resultId',
        sortable: true,
        disabled: true,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'position',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.entity.position',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'designValue',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.entity.designValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'actualValue',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.entity.actualValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'equipNumber',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.entity.equipNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'qualified',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.entity.qualified',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectCommonTemplate.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesQualityInspectCommonTemplate, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs, withOperationFilterConfigs, withOutFilterConfigs

, withOperationVoConfigs, withOutVoConfigs
}
